<template>
  <application-layout>
    <v-main>
      <v-form
        ref="editStaticPageForm"
        @submit.prevent="submitStaticPageForm"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <h1 class="text-capitalize">Edit {{ currentStaticPage.label }}</h1>
            </v-col>
          </v-row>

          <v-tabs>
            <v-tab
              data-testid="static-page-edit-basics-btn"
              class="static-page-edit-basics-btn"
            >
              Basics
            </v-tab>

            <v-tab
              data-testid="static-page-edit-content-sections-btn"
              class="static-page-edit-content-sections-btn"
              v-if="currentStaticPage.sections && currentStaticPage.sections.length"
              @click="launchFroala = true"
            >
              Content Sections
            </v-tab>

            <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
              <seo />
              <custom-code />
            </v-tab-item>

            <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
              <sections
                :launchFroala="launchFroala"
                v-if="currentStaticPage.sections && currentStaticPage.sections.length"
              />
            </v-tab-item>
          </v-tabs>

          <v-row>
            <v-col cols="12">
              <v-btn
                data-testid="static-page-edit-cancel-btn"
                class="static-page-edit-cancel-btn ml-0 mr-3"
                @click="() => { this.$router.back(); }"
                color="error"
              >
                Cancel
              </v-btn>
              <v-btn
                data-testid="static-page-edit-save-btn"
                class="static-page-edit-save-btn"
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import CustomCode from "@/views/static-page/partials/CustomCode.vue";
import Sections from "@/views/static-page/partials/Sections.vue";
import Seo from "@/views/static-page/partials/SEO.vue";

export default {
  data() {
    return {
      loading: true,
      showSection: false,
      launchFroala: false
    };
  },

  computed: {
    darkThemeBgColor() {
      return this.$store.state.app.darkThemeBgColor;
    },
    currentStaticPage: {
      get() {
        return this.$store.state.staticPage.currentStaticPage;
      },
      set(newValue) {
        this.$store.commit("setCurrentStaticPageData", newValue);
      }
    },

    darkTheme() {
      return this.$vuetify.theme.dark;
    }
  },

  methods: {
    async submitStaticPageForm() {
      if (this.$refs.editStaticPageForm.validate()) {
        this.loading = true;
        await this.$store.dispatch("updateStaticPage")
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },

  components: {
    ApplicationLayout,
    Seo,
    CustomCode,
    Sections
  },

  created() {
    this.$store.dispatch("getStaticPage", this.$route.params.staticPageId)
      .then(() => {
        this.loading = false;
      });
  }
};
</script>
